import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperComponent } from './stepper.component';
import { ProgressModule } from '../progress/progress.module';
import { StackModule } from '../stack/stack.module';
import { GridModule } from '../grid/grid.module';

@NgModule({
  declarations: [StepperComponent],
  imports: [CommonModule, ProgressModule, StackModule, GridModule],
  exports: [StepperComponent],
})
export class StepperModule {}
